'use client'

import { useTranslations } from 'next-intl'
import { usePathname, useRouter, useSearchParams } from 'next/navigation'

import Icon from '@/components/ui/icon'
import { CategoryFilters, FilterByParam } from '@/types/category.type'

type SelectedFilterProps = {
  brand: string
  prid: string
  filters: CategoryFilters
  filterByParam: FilterByParam
}

export default function SelectedFilter({ brand, filters, prid, filterByParam }: SelectedFilterProps) {
  const brands = brand.split(',').filter(Boolean).map(Number)
  const prids = prid.split(',').filter(Boolean).map(Number)
  const t = useTranslations('product')
  const searchParams = useSearchParams()
  const pathname = usePathname()
  const router = useRouter()

  // const filteredCategories = filters.category_properties
  //   .map((category) => {
  //     // Lọc children có id tồn tại trong prid
  //     const filteredChildren = category.childrens.filter((child) => prids.includes(child.id))      
  //     // Chỉ giữ lại mục cha nếu có ít nhất một children hợp lệ
  //     if (filteredChildren.length > 0) {
  //       return { ...category, childrens: filteredChildren }
  //     }
  //     return null // Nếu không có children hợp lệ, loại bỏ mục cha
  //   })
  //   .filter(Boolean)
  const filteredCategories = filterByParam.category_properties

  // const filteredSuppliers = filters.suppliers.filter((supplier) => brands.includes(supplier.id))
  const filteredSuppliers = filterByParam.suppliers

  const handleDeleteAll = () => {
    const params = new URLSearchParams(searchParams)
    params.delete('brand')
    params.delete('prid')
    router.push(`${pathname}?${params.toString()}`)
  }

  const handleDeleteOne = (id: number, type: 'brand' | 'prid') => {
    const params = new URLSearchParams(searchParams)

    if (type === 'brand') {
      const newBrands = brands.filter((b) => b !== id)
      params.set('brand', newBrands.join(','))
    } else {
      const newPrids = prids.filter((p) => p !== id)
      params.set('prid', newPrids.join(','))
    }

    router.push(`${pathname}?${params.toString().replace(/%2C/g, ',')}`)
  }

  if (filteredCategories.length === 0 && filteredSuppliers.length === 0) return null

  return (
    <div className="mb-6 p-3 border border-bordercolor rounded-md relative">
      <div className='grid grid-cols-[1fr,auto] gap-3'>
        <div className="space-y-2 ">
          {filteredSuppliers?.length > 0 && (
            <div className=" items-center gap-2 grid grid-cols-[auto,1fr]">
              <div>{t('supplier')}:</div>
              <div className='flex flex-wrap items-center gap-2'>
                {filteredSuppliers?.map((sup) => (
                  <div key={`supplier-${sup.id}`} className="inline-flex items-center gap-2 px-2 py-0.5 bg-[#e9f8ff] border border-bordercolor">
                    <span className="text-sm">{sup.name}</span>
                    <div className="text-[#b77777] cursor-pointer" onClick={() => handleDeleteOne(sup.id, 'brand')}>
                      <Icon icon="tgic icon-times-bold" />
                    </div>
                  </div>
                ))}
              </div>
            </div>
          )}
          {filteredCategories?.length > 0 && (
            <>
              {filteredCategories?.map((cat) => (
                <div key={`catp-${cat?.id}`} className="gap-2 grid grid-cols-[auto,1fr] items-center">
                  <div>{cat?.name}:</div>
                  <div className='flex flex-wrap items-center gap-2'>
                    {cat?.childrens?.map((child) => (
                      <div key={`child-${child.id}`} className="inline-flex items-center gap-2 px-2 py-0.5 bg-[#e9f8ff] border border-bordercolor">
                        <span className="text-sm">{child.name}</span>
                        <div className="text-[#b77777] cursor-pointer" onClick={() => handleDeleteOne(child.id, 'prid')}>
                          <Icon icon="tgic icon-times-bold" />
                        </div>
                      </div>
                    ))}
                  </div>
                </div>
              ))}
            </>
          )}
          {
            searchParams.has('in_stock') && searchParams.get('in_stock') === '1' && (
              <div className="flex flex-wrap items-center gap-2">
                {t('inventory')}:
                <div className="inline-flex items-center gap-2 px-2 py-0.5 bg-[#e9f8ff] border border-bordercolor">
                  <span className="text-sm">{t('has_stock')}</span>
                  <div className="text-[#b77777] cursor-pointer" onClick={() => {
                    const params = new URLSearchParams(searchParams)
                    params.delete('in_stock')
                    router.push(`${pathname}?${params.toString()}`)
                  }}>
                    <Icon icon="tgic icon-times-bold" />
                  </div>
                </div>
              </div>
            )
          }
        </div>
        <div className='flex items-start justify-end'>
          <div className="mb-1 flex justify-end items-center gap-0.5 text-red-600 cursor-pointer text-sm hover:opacity-70" onClick={handleDeleteAll}>
            <Icon icon="tgic icon-trash-solid" className="text-sm" />
            <span>{t('remove_all')}</span>
          </div>
        </div>
      </div>



    </div>
  )
}
